export class GcpDiskTarget {
    'zone';
    'settings';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "zone",
            "baseName": "zone",
            "type": "string",
            "format": ""
        },
        {
            "name": "settings",
            "baseName": "settings",
            "type": "GcpDiskSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpDiskTarget.attributeTypeMap;
    }
    constructor() {
    }
}
